import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { MenuItem } from 'primeng/components/common/api';
import { SideMenuItem } from '../../views/menu/menu.component';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class MenuService {
  private cache: Map<string, KMenuItem[]>;

  constructor(private h: HttpClientService) {
    this.cache = new Map<string, KMenuItem[]>();
  }

  get(menuItem: SideMenuItem, useCache = true, application_id?: number): Observable<KMenuItem[]> {
    let key = null;

    if (menuItem.application_id) {
      key = menuItem.application_id.toString();
    }

    if (this.cache.has(key) && useCache) {
      return Observable.of(this.cache.get(key));
    }

    const req = (application_id == null || application_id === -1) ? '/permissions/menu' : '/permissions/menu/' + application_id;

    return this.h.get(menuItem.ms_base_url + req).map(res => {
      const menu: KMenuItem[] = [];

      res.forEach(entry => {
        menu.push({
          label: entry.description,
          icon: 'fa fa-fw ' + entry.app_icon,
          routerLink: (entry.link_type == "E" || entry.link_type == "T") ? [`/view/${application_id}/${entry.id}/${entry.origin}`] : [entry.link],
          application_id: entry.application_id,
          targetBlank: entry.link_type == "T" ? true : false,
          link: entry.link || null
        });
      });

      if (key) {
        this.cache.set(key, menu);
      }

      return menu;
    });
  }

}

/**
 * Koncentro Menu Item.
 *
 * @param label string (required)
 * @param icon string (required)
 * @param application_id number (required) this identify parent menu (used to group them)
 * @param routerLink string[]
 */
export class KMenuItem implements MenuItem {
  label?: string;
  icon?: string;
  routerLink?: any;
  application_id: number;
  targetBlank?: boolean;
  disabled?: boolean;
  url?: string;
  link?: string;
  items?: MenuItem[] | MenuItem[][];
}



// WEBPACK FOOTER //
// ./src/app/services/utils/menu.service.ts